import { render, staticRenderFns } from "./catalogs.vue?vue&type=template&id=51c146ea&"
import script from "./catalogs.vue?vue&type=script&lang=js&"
export * from "./catalogs.vue?vue&type=script&lang=js&"
import style0 from "./catalogs.vue?vue&type=style&index=0&id=51c146ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports